import { useContext } from 'react';
import { ScrollToExpandedContext } from './ScrollToExpandedContext';
export const useNotifyScrollToExpanded = () => {
    const ctx = useContext(ScrollToExpandedContext);
    return ctx?.notifyContentReady;
};
